import companyLogo from "@assets/images/S&P_Global_logo.svg"

export default function Unauthorized() {
  const mailto = import.meta.env.VITE_SUPPORT_CONTACT

  return (
    <div className="displayContainer">
      <img className="companyLogo" src={companyLogo} alt="S&P Global" />
      <h1>
        401 Unauthorized <b>:(</b>
      </h1>
      <h2>
        You are not permitted to use this service, please contact{" "}
        <a href={`mailto:${mailto}`}>{mailto}</a>
      </h2>
    </div>
  )
}
